export const devPages =
	process.env.NODE_ENV === "development"
		? [
				{
					path: "/trapi-book",
					name: "trapi-book",
					component: () =>
						import(
							/* webpackChunkName: "trapi-book" */ "@/_trapi-book"
						),
					children: [
						{
							path: "/trapi-book/item/:id",
							name: "trapi-book-item",
							component: () =>
								import(
									/* webpackChunkName: "trapi-book" */ "@/_trapi-book"
								),
						},
					],
				},
		  ]
		: [];
